<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="layout-topbar">
    <Button
      icon="ri-layout-left-line"
      class="ml-2 mr-6"
      @click="onMenuToggle"
      rounded
      outlined
      raised
      severity="secondary"
      aria-label="Menu"
    />
    <a :href="topbarPortail" class="layout-topbar-logo">
      <img alt="Logo" :src="topbarImage" />
    </a>
    <div
      class="p-link layout-topbar-menu-button layout-topbar-button mobile_zone ml-auto"
    >
      <button class="p-link layout-topbar-button" @click="searchClickMobile">
        <i class="ri-search-line" />
      </button>
    </div>
    <button
      class="p-link layout-topbar-menu-button layout-topbar-button"
      v-styleclass="{
        selector: '@next',
        enterClass: 'hidden',
        enterActiveClass: 'scalein',
        leaveToClass: 'hidden',
        leaveActiveClass: 'fadeout',
        hideOnOutsideClick: true,
      }"
    >
      <i class="ri-more-2-line" />
    </button>
    <ul class="layout-topbar-menu lg:flex origin-top hidden">
      <li>
        <div class="classic_zone">
          <button
            class="p-link layout-topbar-button"
            v-if="!searchExpand"
            @click="searchClick"
          >
            <i class="ri-search-line" />
          </button>
          <span v-else class="p-input-icon-left">
            <i class="ri-search-line" />
            <InputText
              v-model="searchInput"
              ref="search"
              type="text"
              placeholder="Search"
              @focusout="closeExpand"
              @keyup.enter="search"
            />
          </span>
        </div>
      </li>
      <li>
        <Menu ref="menuOptions" :model="menuOptionsItems" :popup="true">
          <template #item="{ label, item, props }">
            <router-link
              v-if="item.route"
              v-slot="routerProps"
              :to="item.route"
              custom
            >
              <a :href="routerProps.href" v-bind="props.action">
                <span v-bind="props.icon" />
                <span v-bind="props.label">{{ label }}</span>
              </a>
            </router-link>
            <a v-else :href="item.url" v-bind="props.action">
              <span v-bind="props.icon" />
              <span v-bind="props.label">{{ label }}</span>
            </a>
          </template>
        </Menu>
        <button
          class="p-link layout-topbar-button"
          @click="toggleMenuOptions($event)"
          v-tooltip.bottom="$t('settingsMenu')"
        >
          <i class="ri-settings-3-line" />
          <span>{{ $t("settingsMenu") }}</span>
        </button>
      </li>
      <li>
        <button
          class="p-link layout-topbar-button"
          @click="onProfileButton"
          v-tooltip.bottom="displayName"
        >
          <i class="ri-user-3-line" />
          <span>{{ displayName }}</span>
        </button>
      </li>
      <li>
        <button
          class="p-link layout-topbar-button"
          @click="onButtonLogout"
          v-tooltip.bottom="this.$t('logoutButton')"
        >
          <i class="ri-logout-circle-r-line" />
          <span>{{ $t("logoutButton") }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useUserStore, useConfigStore } from "@pristy/pristy-libvue";

export default {
  data() {
    return {
      menuOptionsItems: [],
      searchExpand: false,
      searchInput: null,
    };
  },
  methods: {
    searchClickMobile() {
      window.location = `${this.ALFRESCO_HOST}${this.APP_ROOT}recherche`;
    },
    search() {
      window.location = `${this.ALFRESCO_HOST}${this.APP_ROOT}recherche?search=${this.searchInput}`;
    },
    closeExpand() {
      this.searchExpand = false;
      this.searchInput = "";
    },
    searchClick() {
      this.searchExpand = true;
      this.$nextTick(() => {
        this.$refs.search.$el.focus();
      });
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    onTopbarMenuToggle(event) {
      this.$emit("topbar-menu-toggle", event);
    },
    onProfileButton() {
      window.location = `${this.PORTAIL_HOST}/portail/profile`;
    },
    toggleMenuOptions(event) {
      this.menuOptionsItems = [
        {
          label: this.$t("trashcan.name"),
          icon: "ri-delete-bin-line",
          command: () => {
            window.location = `${this.PORTAIL_HOST}/portail/corbeille`;
          },
        },
      ];
      this.$refs.menuOptions.toggle(event);
    },
    onButtonLogout() {
      useUserStore().logout();
      if (this.AUTH === "basic") {
        this.$router.push({
          name: "login",
        });
      }
    },
  },
  computed: {
    ...mapState(useUserStore, ["displayName"]),
    ...mapState(useConfigStore, [
      "AUTH",
      "APP_ROOT",
      "PORTAIL_HOST",
      "ALFRESCO_HOST",
    ]),
    darkTheme() {
      return this.$appState.darkTheme;
    },
    topbarImage() {
      return `${this.APP_ROOT}images/pristy/logo-pristy-espaces.png`;
    },
    topbarPortail() {
      return `${this.PORTAIL_HOST}/portail`;
    },
  },
};
</script>
